import addressGroup from './addressGroup';
import asset from './asset';
import dashboard from './dashboard';
import program from './program';

export default { program, asset, addressGroup, dashboard };
